export const environment = {
  production: false,
  insuredApiUrl: 'https://albert-dev.fflight.cloud/api/albert/insured',
  memberApiUrl: 'https://albert-dev.fflight.cloud/api/albert/member',
  periodApiUrl: 'https://albert-dev.fflight.cloud/api/albert/period',
  policyApiUrl: 'https://albert-dev.fflight.cloud/api/albert/policy',
  coverageApiUrl: 'https://albert-dev.fflight.cloud/api/albert/coverage',
  subcoverageApiUrl: 'https://albert-dev.fflight.cloud/api/albert/subcoverage',
  referenceApiUrl: 'https://albert-dev.fflight.cloud/api/albert/reference',
  cuApiUrl: 'https://albert-dev.fflight.cloud/api/albert/content/unit',
  templateApiUrl: 'https://albert-dev.fflight.cloud/api/albert/content/template',
  chApiUrl: 'https://albert-dev.fflight.cloud/api/albert/certificateholder',
  certificateApiUrl: 'https://albert-dev.fflight.cloud/api/albert/certificate',
  documentApiUrl: 'https://albert-dev.fflight.cloud/api/albert/document',
  httpInterceptorPattern: '',
  origamiBaseUrl: 'https://live.origamiriskeu.com',
  flagsmithApiUrl: 'https://flagsmith.fflight.cloud/api/v1/',
  flagsmithEnvironmentId: 'BabfGEqVthuDQbTqFBgGaZ',
  oidcProviderUrl: 'https://sso.fflight.cloud/realms/albert',
  oidcClientId: 'albert-frontend',
  oidcScopes: 'openid offline_access profile email roles',
  requiredBaseGroup: 'ALB_ALBERT_USER_T'
}
